(() => {
  const HEADER_SELECTOR = '.header'; // заміни, якщо інший селектор фіксованого хедера
  const header = document.querySelector(HEADER_SELECTOR);
  const getOffset = () =>
    header && getComputedStyle(header).position === 'fixed' ? header.offsetHeight : 0;

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.header-scroll');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault();

    const top = target.getBoundingClientRect().top + window.pageYOffset - getOffset();
    window.scrollTo({ top, behavior: 'smooth' });

    // оновлюємо hash без стрибка сторінки
    history.pushState(null, '', href);
  });
})();

(() => {
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];
  const mq = window.matchMedia('(max-width:600px)');

  const burger = $('.header__burger');
  const menu   = $('#header-menu');

  if (!burger || !menu) return;

  const openMenu = () => {
    burger.classList.add('is-active');
    menu.classList.add('is-open');
    menu.style.maxHeight = menu.scrollHeight + 'px';
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
  };

  const closeMenu = () => {
    burger.classList.remove('is-active');
    menu.classList.remove('is-open');
    menu.style.maxHeight = '0px';
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  };

  const toggleMenu = () => (menu.classList.contains('is-open') ? closeMenu() : openMenu());

  // toggle on click
  burger.addEventListener('click', toggleMenu);

  // close on link click inside mobile menu
  menu.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    if (mq.matches) closeMenu();
  });

  // close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
  });

  // reset on resize to desktop
  const onResize = () => {
    if (!mq.matches){
      // desktop
      closeMenu();
      menu.style.maxHeight = ''; // cleanup
    }
  };
  window.addEventListener('resize', onResize, { passive:true });
})();


